export default {
    ymdToDate(s) {
        let result = null
        let sp = s.split('-')

        if (sp.length == 3) {
            let y = Number.parseInt(sp[0])
            let m = Number.parseInt(sp[1])
            let d = Number.parseInt(sp[2])
            
            if (!Number.isNaN(y) &&
                !Number.isNaN(m) &&
                !Number.isNaN(d))
            {
                result = new Date(y, (m-1), d)
            }
        }
        return result
    },
    addMonths(date, count) {
        let year = date.getFullYear()
        let month = date.getMonth()
        let day = date.getDate()    

        return new Date(year, month + Number(count), day)
    }
}